import { render, staticRenderFns } from "./ReOrderBtn.vue?vue&type=template&id=bb7ca310&"
import script from "./ReOrderBtn.vue?vue&type=script&lang=js&"
export * from "./ReOrderBtn.vue?vue&type=script&lang=js&"
import style0 from "./ReOrderBtn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports